import React, { useState, useMemo, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Shared/Sales-ExecutiveNavbar/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaEdit, FaDownload, FaEye, FaComment, FaTrash, FaCalendarAlt,FaSave, FaTimes, FaCopy,FaSpinner,FaRupeeSign } from "react-icons/fa";
import { Row, Col, Modal, Form ,Button} from "react-bootstrap";
import DataTable from "../../../Layout/Table/TableLayoutOpp";
import { baseURL } from "../../../Apiservices/Api";
import './PotentialLeads.css';
import axios from 'axios';
import { AuthContext } from '../../../AuthContext/AuthContext';
import { FontSizeContext } from "../../../Shared/Font/FontContext";
import * as XLSX from 'xlsx';
import {  useLocation} from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { adminMail } from '../../../Apiservices/Api';
import EmailCommentModalPopemployee from "../../Admin/Leads/ViewLeads/Comment/EmailCommentModalPop/EmailCommentModalPopemployee";

import Loader from "../../../Loader/Loader";

const Potentialleads = () => { 
  const { authToken, userId ,userName,userEmail} = useContext(AuthContext);
const queryClient = useQueryClient();

  const {
  data: leads = [],
  isLoading,
  isError,
  error,
} = useQuery({
  queryKey: ['salesman-leads', userId], // 🔥 important
    refetchInterval: 3000, // every 30 sec
  queryFn: async () => {
    if (!userId) return [];

    const response = await axios.get(
      `${baseURL}/api/fetch-data-salesman`,
      { params: { userId } }
    );

    return response.data;
  },
  enabled: !!userId, // only run if userId exists
});


  const [message, setMessage] = useState(""); 
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  // Comment Modal States
const [showCommentModal, setShowCommentModal] = useState(false);
const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
  const [searchTerm, setSearchTerm] = useState(localStorage.getItem("searchTerm") || "");
  const [filterStatus, setFilterStatus] = useState(localStorage.getItem("filterStatus") || "");
  const [filterDestination, setFilterDestination] = useState(localStorage.getItem("filterDestination") || "");
  const [filterOppStatus1, setFilterOppStatus1] = useState(localStorage.getItem("filterOppStatus1") || "In Progress");
  const [filterOppStatus2, setFilterOppStatus2] = useState(localStorage.getItem("filterOppStatus2") || "");

  const [filterPrimarySource, setFilterPrimarySource] = useState(
  localStorage.getItem("filterPrimarySource") || ""
);

const [filterSecondarySource, setFilterSecondarySource] = useState(
  localStorage.getItem("filterSecondarySource") || ""
);

  const [filterAssignee, setFilterAssignee] = useState(localStorage.getItem("filterAssignee") || "");
  const [filterStartDate, setFilterStartDate] = useState(localStorage.getItem("filterStartDate") || "");
  const [filterEndDate, setFilterEndDate] = useState(localStorage.getItem("filterEndDate") || "");
  const [appliedFilterStartDate, setAppliedFilterStartDate] = useState(localStorage.getItem("appliedFilterStartDate") || "");
  const [appliedFilterEndDate, setAppliedFilterEndDate] = useState(localStorage.getItem("appliedFilterEndDate") || "");
  // const [showDateRange, setShowDateRange] = useState(false);
  const [showDateRange, setShowDateRange] = useState(localStorage.getItem("showDateRange") === "true");
  // const [data, setData] = useState([]);
  const [employees, setEmployees] = useState([]); // State for employees
    const location = useLocation();
  const [pageIndex, setPageIndex] = useState(0);

  const [loading, setLoading] = useState(false);

  const primarySourceOptions = [
  "Referral",
  "Corporate",
  "Partner Promotion",
  "Media Coverage",
  "Blog",
  "Community",
  "Purchased Leads",
  "Social Media",
  "Google",
  "Meta",
  "Other",
];

  const sourceDropdownOptions = {
  Referral: ["Grade 3", "Grade 2", "Grade 1"],
  Corporate: ["BIW", "Others"],
  Community: ["BNI", "Rotary", "Lions", "Association", "Others"],
  "Purchased Leads": ["Tripcrafter", "Others"],
  "Social Media": ["Linkedin", "Others"],
  Google: [
    "Google Organic",
    "Google Ad",
    "Youtube Organic",
    "Youtube Paid",
  ],
  Meta: [ 
    "Facebook Organic",
    "Instagram Organic",
    "Facebook (Paid)",
    "Instagram (Paid)",
    "Others",
  ],
};

  // Save state to localStorage when values change
  useEffect(() => {
    localStorage.setItem("showDateRange", showDateRange);
  }, [showDateRange]);




  // const fetchLeads = async () => {
  //   try {
  //     const response = await axios.get(`${baseURL}/api/fetch-data`);
  //     if (response.status == 200) {
  //       const leads = response.data;
  //       const filteredLeads = leads.filter(
  //         (enquiry) =>
  //           enquiry.assignedSalesId == userId && enquiry.status == "opportunity"
  //       );
  //       console.log("opportunity data :", filteredLeads);
  //       setData(filteredLeads);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching leads:", error);

  //   }
  // };


//   const fetchLeads = async () => {
//     setLoading(true); // Start loading
//   try {
//     const response = await axios.get(`${baseURL}/api/fetch-data-salesman`, {
//       params: { userId }
//     });
//     setData(response.data);
//   } catch (error) {
//     console.error("Error fetching leads:", error);
//   }finally {
//     setLoading(false); // Stop loading
//   }
// };


  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);  // Optional: Show a message
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });


  };

  const fetchEmployees = async () => {
      setLoading(true); // Start loading
    try {
      const response = await axios.get(`${baseURL}/employeesassign`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }finally {
    setLoading(false); // Stop loading
  }
  };

  useEffect(() => {
    // fetchLeads();
    fetchEmployees(); // Fetch employees when the component mounts
  }, [userId]);

  const [dropdownOptions, setDropdownOptions] = useState({
    primary: [],
    secondary: {}
  });
  
  useEffect(() => {
    fetchLeadStatus();
  }, []);
  
  const fetchLeadStatus = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/opp-status`);
      
      setDropdownOptions({
        primary: res.data.primary || [],
        secondary: res.data.secondary || {}
      });
  
    } catch (error) {
      console.error("Error fetching lead status:", error);
    }
  };

  // const dropdownOptions = {
  //   primary: ["In Progress", "Confirmed", "Lost", "Duplicate"],
  //   secondary: {
  //     "In Progress": [
  //       "Understood Requirement",
  //       "Sent first quote",
  //       "Amendment Requested",
  //       "Sent amended quote",
  //       "Negotiation Process",
  //       "Verbally Confirmed-Awaiting token amount",
  //     ],
  //     Confirmed: ["Upcoming Trip", "Ongoing Trip", "Trip Completed"],
  //     Lost: [
  //       "Plan Cancelled",
  //       "Plan Postponed",
  //       "High Quote",
  //       "Low Budget",
  //       "No response",
  //       "Options not available",
  //       "just checking price",
  //       "Self Booked",
  //       "Booked from other source",
  //       "Delay in quote",
  //       "Concern about reliability/trust",
  //       "Did not like payment terms",
  //       "Did not like cancellation policy",
  //       "Booked different option from us",
  //     ],
  //     Duplicate: ["Duplicate"],
  //   },
  // };

  // const handlePrimaryStatusChange = (value, rowId) => {
  //   setData((prevData) => {
  //     const updatedData = prevData.map((row) =>
  //       row.leadid == rowId
  //         ? { ...row, opportunity_status1: value, opportunity_status2: "" }
  //         : row
  //     );
  //     // handleUpdateStatus(rowId, value, "");
  //     return updatedData;
  //   });
  // };

  // const handleSecondaryStatusChange = (value, rowId) => {
  //   setData((prevData) => {
  //     const updatedData = prevData.map((row) =>
  //       row.leadid == rowId ? { ...row, opportunity_status2: value } : row
  //     );
  //     const primaryStatus = updatedData.find((row) => row.leadid == rowId).opportunity_status1;
  //     // handleUpdateStatus(rowId, primaryStatus, value);
  //     return updatedData;
  //   });
  // };

 
const updateOpportunityStatus = async (leadId, primaryStatus, secondaryStatus) => {
  // ✅ Optimistic — instant UI update
  queryClient.setQueryData(['salesman-leads', userId], (old = []) =>
    old.map((r) =>
      r.leadid === leadId
        ? {
            ...r,
            opportunity_status1: primaryStatus,
            opportunity_status2: secondaryStatus || '',
          }
        : r
    )
  );
 
  try {
    const response = await axios.put(`${baseURL}/api/update-status/${leadId}`, {
      opportunity_status1: primaryStatus,
      opportunity_status2: secondaryStatus || '',
    });
    if (response.status === 200) {
      setMessage('Status updated successfully.');
      setTimeout(() => setMessage(''), 3000);
      return true;
    }
  } catch {
    queryClient.invalidateQueries(['salesman-leads', userId]); // ✅ rollback
    setMessage('Update failed, reverting...');
    setTimeout(() => setMessage(''), 3000);
  }
  return false;
};

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const pageFromUrl = parseInt(params.get("page"));

  if (!isNaN(pageFromUrl)) {
    setPageIndex(pageFromUrl - 1); 
  }
}, [location.search]);

  
  const navigateToLead = (leadId,currentPage) => {
        const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';


    navigate(`/details/${leadId}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: leadId },
    });
  };


const handleCommentClick = (lead) => {
  setSelectedLeadForComment(lead);
  setShowCommentModal(true);
};
  const handleEdit = (leadId,currentPage) => {
        const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';


    navigate(`/edit-opportunity/${leadId}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: leadId },
    });
  };



  useEffect(() => {
    localStorage.setItem("searchTerm", searchTerm);
    localStorage.setItem("filterStatus", filterStatus);
    localStorage.setItem("filterDestination", filterDestination);
    localStorage.setItem("filterOppStatus1", filterOppStatus1);
    localStorage.setItem("filterOppStatus2", filterOppStatus2);
    localStorage.setItem("filterPrimarySource", filterPrimarySource);
    localStorage.setItem("filterSecondarySource", filterSecondarySource);

    localStorage.setItem("filterAssignee", filterAssignee);
    localStorage.setItem("filterStartDate", filterStartDate);
    localStorage.setItem("filterEndDate", filterEndDate);
    localStorage.setItem("appliedFilterStartDate", appliedFilterStartDate);
    localStorage.setItem("appliedFilterEndDate", appliedFilterEndDate);
  }, [
    searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2, filterPrimarySource, filterSecondarySource,
    filterAssignee, filterStartDate, filterEndDate,
    appliedFilterStartDate, appliedFilterEndDate
  ]);

  const clearFilters = () => {
    setSearchTerm("");
    setFilterStatus("");
    setFilterDestination("");
    setFilterOppStatus1("In Progress");
    setFilterOppStatus2("");
    setFilterPrimarySource("");
    setFilterSecondarySource("");
      setFilterAssignee("");
    setFilterStartDate("");
    setFilterEndDate("");
    setAppliedFilterStartDate("");
    setAppliedFilterEndDate("");
     setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
          url.searchParams.set('pageSize', '20'); 
      url.searchParams.delete('pageSize');
                    window.history.pushState({}, '', url);
    localStorage.removeItem("potentialLeadsFilters");
  };

  const filteredData = useMemo(() => {
    return leads.filter((item) => {
      const matchesFreeText = !searchTerm || Object.values(item).some(val => val && val.toString().toLowerCase().includes(searchTerm.toLowerCase()));
      const matchesStatus = !filterStatus || (item.status && item.status.toLowerCase() == filterStatus.toLowerCase());
      const matchesDestination = !filterDestination || (item.travel_destination && item.travel_destination.toLowerCase() == filterDestination.toLowerCase());
      const actualPrimaryStatus = item.opportunity_status1 ? item.opportunity_status1.toLowerCase() : "In Progress";
      const matchesOppStatus1 =
        !filterOppStatus1 || actualPrimaryStatus === filterOppStatus1.toLowerCase();
      const matchesOppStatus2 = !filterOppStatus2 || (item.opportunity_status2 && item.opportunity_status2.toLowerCase() == filterOppStatus2.toLowerCase());
      const matchesPrimarySource =
  !filterPrimarySource ||
  (item.primarySource &&
    item.primarySource.toLowerCase() === filterPrimarySource.toLowerCase());

const matchesSecondarySource =
  !filterSecondarySource ||
  (item.secondarysource &&
    item.secondarysource.toLowerCase() === filterSecondarySource.toLowerCase());
      const matchesAssignee = !filterAssignee || (item.assignedSalesName && item.assignedSalesName.toLowerCase() == filterAssignee.toLowerCase());
      const matchesDateRange = (() => {
        if (appliedFilterStartDate && appliedFilterEndDate) {
          const start = new Date(appliedFilterStartDate);
          const end = new Date(appliedFilterEndDate).setHours(23, 59, 59, 999);
          const createdAt = new Date(item.travel_created_at);
          return createdAt >= start && createdAt <= end;
        }
        return true;
      })();

      return matchesFreeText && matchesStatus && matchesDestination && matchesOppStatus1 && matchesOppStatus2 && matchesAssignee && matchesDateRange &&
  matchesPrimarySource &&
  matchesSecondarySource;
    });
  }, [searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2, filterAssignee, appliedFilterStartDate, appliedFilterEndDate, leads, filterPrimarySource,
filterSecondarySource,]);

  const columns = useMemo(() => [
    { Header: "OppId", accessor: "leadid" },
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ row }) => {
        const currentPage = pageIndex; 
        const params = new URLSearchParams(location.search);
        const pageSize = params.get('pageSize') || '20';
        return (
          <div style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }} onClick={() => navigate(`/details/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: row.original.leadid } })}>
            {row.original.name}
          </div>
        );
      },
    },
    {
      Header: "Mobile",
      accessor: "phone_number",
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href={`https://wa.me/${row.original.phone_number}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "blue", cursor: "pointer" }}
            title="Chat on WhatsApp"
          >
            {row.original.phone_number}
          </a>
          <FaCopy
            style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
            onClick={() => copyToClipboard(row.original.phone_number)}
            title="Copy Phone Number"
          />
        </div>
      ),
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: ({ row }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between", // Push copy button to the right
            width: "100%",
            maxWidth: "200px", // Adjust width as needed
          }}
        >
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px",
            }}
            title={row.original.email} // Show full email on hover
          >
            {row.original.email}
          </div>
          <FaCopy
            style={{ cursor: "pointer", color: "#ff9966" }}
            onClick={() => copyToClipboard(row.original.email)}
            title="Copy Email"
          />
        </div>
      ),
    },
    {
        Header: "Destination",
        accessor: "travel_destination",
        Cell: ({ row }) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px",
            }}
            title={row.original.travel_destination}
          >
            {row.original.travel_destination}
          </div>
        ),
      },


   {

     Header: "Opportunity Status",
     accessor: "opportunityStatus",
     Cell: ({ row }) => {
       const { fontSize } = useContext(FontSizeContext);
       const { opportunity_status1, opportunity_status2, leadid } = row.original;
       
       // Local state for unsaved changes
       const [localPrimary, setLocalPrimary] = useState(opportunity_status1);
       const [localSecondary, setLocalSecondary] = useState(opportunity_status2);
       const [isDirty, setIsDirty] = useState(false);
   
       // Reset local state when original props change
       useEffect(() => {
         setLocalPrimary(opportunity_status1);
         setLocalSecondary(opportunity_status2);
         setIsDirty(false);
       }, [opportunity_status1, opportunity_status2]);
   
       // Get secondary options for current primary selection
       const secondaryOptions = localPrimary ? (dropdownOptions.secondary[localPrimary] || []) : [];
       const isSecondaryDisabled = !localPrimary || secondaryOptions.length === 0;
   
       const handlePrimaryChange = (e) => {
         const newPrimary = e.target.value;
         setLocalPrimary(newPrimary);
         setLocalSecondary(""); // Reset secondary when primary changes
         setIsDirty(true);
       };
   
       const handleSecondaryChange = (e) => {
         setLocalSecondary(e.target.value);
         setIsDirty(true);
       };

   

           const canSave =
  localPrimary && 
  (secondaryOptions.length === 0 || (secondaryOptions.length > 0 && localSecondary));
   
       const handleSave = async () => {
         try {
           // Update both statuses in one API call
           await updateOpportunityStatus(leadid, localPrimary, localSecondary);
           
           // Update local data state only after successful API call
          queryClient.setQueryData(
  ['salesman-leads', userId],
  (oldData = []) =>
    oldData.map(row =>
      row.leadid === leadid
        ? {
            ...row,
            opportunity_status1: localPrimary,
            opportunity_status2: localSecondary
          }
        : row
    )
);

           
           setIsDirty(false);
         } catch (error) {
           console.error('Error saving status:', error);
         }
       };
   
       return (
         <div className="d-flex align-items-center gap-2" style={{ fontSize }}>
           {/* Primary Status Dropdown */}
           <select
             value={localPrimary || ""}
             onChange={handlePrimaryChange}
             className="form-select"
             style={{ fontSize }}
           >
             <option value="">Select Primary Status</option>
             {dropdownOptions.primary.map(option => (
               <option key={option} value={option}>{option}</option>
             ))}
           </select>
   
           {/* Secondary Status Dropdown */}
           <select
             value={localSecondary || ""}
             onChange={handleSecondaryChange}
             className="form-select"
             style={{ fontSize }}
             disabled={isSecondaryDisabled}
           >
             <option value="">Select Secondary Status</option>
             {secondaryOptions.map(option => (
               <option key={option} value={option}>{option}</option>
             ))}
           </select>
   
           {/* Save Button (only shown when there are unsaved changes) */}
         {isDirty && (
           <FaSave
             onClick={canSave ? handleSave : undefined}
             title={canSave ? "Save changes" : "Select secondary status to enable"}
             style={{
               color: canSave ? "#ff9966" : "#ccc",
               cursor: canSave ? "pointer" : "not-allowed",
               fontSize: "32px"
             }}
           />
         )}
         </div>
       );
     },
   },
    {
      Header: "Action",
    Cell: ({ row }) => {
      const currentPage = pageIndex; // Capture current page index
              const params = new URLSearchParams(location.search);
        const pageSize = params.get('pageSize') || '20';


return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <FaEdit
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => handleEdit(row.original.leadid,currentPage, pageSize)}
          />
          <FaEye
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => navigateToLead(row.original.leadid,currentPage, pageSize)}
          />
               {/* <FaComment
                     style={{ color: "#ff9966", cursor: "pointer" }}
                     onClick={() => navigate(`/m-opportunity-comments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: row.original.leadid } })}
                   /> */}
                     <FaComment
                                                           style={{ color: "#ff9966", cursor: "pointer" }}
                                                           onClick={() => handleCommentClick(row.original,)}
                                                         />
            <FaRupeeSign
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() =>
              navigate(`/s-payments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, {
                state: { leadid: row.original.leadid },
              })
            }
          />
        
        </div>
      )
    }
    },

  ], [dropdownOptions,pageIndex,location]);

  const uniqueDestinations = useMemo(() => {
    // Filter out empty destinations and normalize valid ones
    const normalizedDestinations = leads
      .map(item => item.travel_destination?.trim()) // Trim spaces and handle potential undefined/null values
      .filter(dest => dest) // Remove empty values
      .map(dest => dest.toLowerCase()); // Convert to lowercase for uniqueness

    // Get unique values and format them
    return [...new Set(normalizedDestinations)]
      .map(dest => dest.charAt(0).toUpperCase() + dest.slice(1)); // Capitalize first letter
  }, [leads]);

  // const uniqueDestinations = useMemo(() => {
  //   if (!data || !Array.isArray(data)) return []; // Ensure data is valid

  //   // Normalize and filter out invalid values
  //   const normalizedDestinations = data
  //     .map(item => item.travel_destination?.trim().toLowerCase()) // Use optional chaining (?.)
  //     .filter(Boolean); // Remove null, undefined, and empty values

  //   // Use a Set to get unique values, then convert back to the original format
  //   const uniqueNormalizedDestinations = [...new Set(normalizedDestinations)];

  //   // Capitalize the first letter
  //   return uniqueNormalizedDestinations.map(dest => dest.charAt(0).toUpperCase() + dest.slice(1));
  // }, [data]);

  return (
    <div className="salesOpportunitycontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesOpportunity ${collapsed ? "collapsed" : ""}`}>
        <div className="potentialleads-table-container">
          <Row className="mb-3">
            <Col className="d-flex justify-content-between align-items-center fixed">
              <h3>Opportunity Details</h3>
              {message && <div className="alert alert-info">{message}</div>}
              {/* <button className="btn btn-success" onClick={downloadExcel}>
                <FaDownload /> Download Excel</button> */}
            </Col>
          </Row>
          <Row className="mb-3 align-items-center">
            <Col md={6} className="d-flex align-items-center gap-2">
              <input type="text" className="form-control" placeholder="Free Text Search..." value={searchTerm} onChange={(e) => {
                setSearchTerm(e.target.value);
                localStorage.setItem("searchTerm", e.target.value);
                  setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
              }} />
              {showDateRange ? (
                <FaTimes
                  onClick={() => {
                    setShowDateRange(false);
                    localStorage.setItem("showDateRange", "false");
                    setFilterStartDate("");
                    setFilterEndDate("");
                    setAppliedFilterStartDate("");
                    setAppliedFilterEndDate("");
                    localStorage.removeItem("filterStartDate");
                    localStorage.removeItem("filterEndDate");
                    localStorage.removeItem("appliedFilterStartDate");
                    localStorage.removeItem("appliedFilterEndDate");
                  }} style={{ cursor: "pointer", fontSize: "1.5rem" }} title="Hide Date Range" />
              ) : (
                <FaCalendarAlt  onClick={() => {
                  setShowDateRange(true);
                  localStorage.setItem("showDateRange", "true");
                }} style={{ cursor: "pointer", fontSize: "1.5rem" }} title="Show Date Range" />
              )}
              {showDateRange && (
                <div className="d-flex align-items-center gap-2">
                  <input type="date" className="form-control" value={filterStartDate} onChange={(e) => setFilterStartDate(e.target.value)} />
                  <span>to</span>
                  <input type="date" className="form-control" value={filterEndDate} onChange={(e) => setFilterEndDate(e.target.value)} />
                  <button className="btn btn-primary" onClick={() => { setAppliedFilterStartDate(filterStartDate); setAppliedFilterEndDate(filterEndDate); 
                     setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}>OK</button>
                </div>
              )}
            </Col>
            <Col md={6} className="d-flex justify-content-end">
              <button className="btn btn-secondary" onClick={clearFilters}>Clear Filters</button></Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <select className="form-select" value={filterDestination} onChange={(e) =>{ setFilterDestination(e.target.value)
                 setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);}
              }>
                <option value="">Destinations</option>
                {uniqueDestinations.map((dest) => (
                  <option key={dest} value={dest}>{dest}</option>
                ))}
              </select>
            </Col>
            <Col md={2}>
              <select className="form-select" value={filterOppStatus1} onChange={(e) => { setFilterOppStatus1(e.target.value); setFilterOppStatus2("");  setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);}}>
                <option value="">Primary Status</option>
                {dropdownOptions.primary.map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </Col>
            <Col md={3}>
              <select className="form-select" value={filterOppStatus2} onChange={(e) =>{ setFilterOppStatus2(e.target.value)
                 setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);}
              }>
                <option value="">Secondary Status</option>
                {dropdownOptions.secondary[filterOppStatus1]?.map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </Col>
            <Col md={2}>
  <select
    className="form-select"
    value={filterPrimarySource}
    onChange={(e) => {
      setFilterPrimarySource(e.target.value);
      setFilterSecondarySource(""); // reset secondary
      setPageIndex(0);

      const url = new URL(window.location);
      url.searchParams.delete("page");
      window.history.pushState({}, "", url);
    }}
  >
    <option value="">Primary Source</option>
   {primarySourceOptions.map((source) => (
      <option key={source} value={source}>
        {source}
      </option>
    ))}
  </select>
</Col>
<Col md={2}>
  <select
    className="form-select"
    value={filterSecondarySource}
    onChange={(e) => {
      setFilterSecondarySource(e.target.value);
      setPageIndex(0);

      const url = new URL(window.location);
      url.searchParams.delete("page");
      window.history.pushState({}, "", url);
    }}
    disabled={!filterPrimarySource}
  >
    <option value="">Secondary Source</option>
    {sourceDropdownOptions[filterPrimarySource]?.map((source) => (
      <option key={source} value={source}>
        {source}
      </option>
    ))}
  </select>
</Col>

          </Row>
         {isLoading ? (
                                  <Loader />
                                ) : leads.length === 0 ? (
                                            <div className="text-center p-5">
                                              <p>No data available</p>
                                            </div>
                                          ) : (
 <DataTable 
                columns={columns} 
                data={filteredData} 
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
              />
        )}
        </div>
      </div>
   {/* Comment Modal Component */}
<EmailCommentModalPopemployee
  show={showCommentModal}
  onHide={() => {
    setShowCommentModal(false);
    setSelectedLeadForComment(null);
  }}
  selectedLead={selectedLeadForComment}
  userName={userName}
  userEmail={userEmail}
/>
    </div>
  );
};

export default Potentialleads;
